import { HintAnimation } from './hint-motion';
import { CreateKnowledgeBaseAnimation } from './animations/create-knowledge-base.animation';
import { LinkKnowledgeBaseAnimation } from './animations/link-knowledge-base.animation';
import { LimitKnowledgeAnimation } from './animations/limit-knowledge.animation';
import { CreditsTrialAnimation } from './animations/credits-trial.animation';
import { ConnectLmsAnimation } from './animations/connect-lms.animation';
import { PlaceAgentsAnimation } from './animations/place-agents.animation';
import { meetOrbiAnimation } from './animations/meet-orbi.animation';
import { visitAcademyAnimation } from './animations/visit-academy.animation';
import { createAgentAnimation } from './animations/create-agent.animation';
import { tryAgentAnimation } from './animations/try-agent.animation';
import { styleChatAnimation } from './animations/style-chat.animation';
import { reviewConversationsAnimation } from './animations/review-conversations.animation';
import { inviteTeamAnimation } from './animations/invite-team.animation';

/**
 * Die Erklärfilme der Portal-Hinweise, je Hinweis-ID (= `HintDef.id`, nie
 * umbenennen). Eine Quelle für zwei Abspielorte: die Hinweis-Box unten links
 * und die verknüpfte Academy-Lektion (`academy-catalog.ts`, `video.kind =
 * 'hint'`) — ein Film wird so nie doppelt gepflegt.
 */
export const HINT_FILMS = {
  'create-knowledge-base': () => new CreateKnowledgeBaseAnimation(),
  'link-knowledge-base': () => new LinkKnowledgeBaseAnimation(),
  'limit-knowledge': () => new LimitKnowledgeAnimation(),
  'credits-trial': () => new CreditsTrialAnimation(),
  'connect-lms': () => new ConnectLmsAnimation(),
  'place-agents': () => new PlaceAgentsAnimation(),
  'meet-orbi': meetOrbiAnimation,
  'visit-academy': visitAcademyAnimation,
  'create-agent': createAgentAnimation,
  'try-agent': tryAgentAnimation,
  'style-chat': styleChatAnimation,
  'review-conversations': reviewConversationsAnimation,
  'invite-team': inviteTeamAnimation,
} satisfies Record<string, () => HintAnimation>;

export type HintId = keyof typeof HINT_FILMS;
